/**
 * First letters of the first two words, e.g. "Maguida AI" -> "MA".
 *
 * Shared by the card and the case study so a project without a cover gets the
 * same mark in both places, and the two can never drift apart.
 */
export const initialsOf = (title: string): string =>
  title
    .split(/\s+/)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase() ?? '')
    .join('')
